import { useSelector } from "react-redux";
import { skuSelector } from "../redux/cart";

export function useSkuPriceTiering(skuId, skuInitNextTier = null) {
  const cartSku = useSelector((state) => skuSelector(state, skuId));

  let skuTotalPrice = 0;
  let skuTotalPriceAfterDiscount = 0;
  let isSkuTotalPriceVisible = false;
  let nextPriceTier = skuInitNextTier;

  if (cartSku && cartSku.hasPriceTiers) {
    skuTotalPrice = cartSku.quantity * cartSku.inventoryPrice;
    skuTotalPriceAfterDiscount = cartSku.totalPriceAfter || skuTotalPrice;
    isSkuTotalPriceVisible = skuTotalPriceAfterDiscount < skuTotalPrice;
    nextPriceTier = cartSku.nextPriceTier;
  }

  return {
    isSkuTotalPriceVisible,
    skuTotalPrice,
    skuTotalPriceAfterDiscount,
    nextPriceTier,
  };
}
